import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-conference-accept",
  "use": "icon-conference-accept-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-conference-accept\"><g fill=\"#60CE64\" fill-rule=\"evenodd\"><path d=\"M8 14.396A6.222 6.222 0 1 1 8 1.95a6.222 6.222 0 0 1 0 12.445ZM8 2.828a5.346 5.346 0 1 0 0 10.691A5.346 5.346 0 0 0 8 2.828Z\" fill-rule=\"nonzero\" /><path d=\"m4.504 8.458.37-.526 1.788 1.374L11.1 5.788l.404.391-4.842 4.609z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol